import type {
  ProgrammaticAdviceRecoLevel,
  ProgrammaticAdviceRecoProduct,
} from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.model';
import type { HydrateAction } from '@/domains/core/applicationState/store/hydrateAction';
import type { SpartacuxDigitalAdviceState } from '@/domains/digitalAdvice/digitalAdvice.model';

export const COMPUTE_PROGRAMMATIC_ADVICE_RECO_SIZE =
  'digitalAdvice/recommendation/COMPUTE_PROGRAMMATIC_ADVICE_RECO_SIZE';
export const FETCH_PROGRAMMATIC_ADVICE_RECO_FAILED =
  'digitalAdvice/recommendation/FETCH_PROGRAMMATIC_ADVICE_RECO_FAILED';
export const FETCH_PROGRAMMATIC_ADVICE_RECO_SUCCESS =
  'digitalAdvice/recommendation/FETCH_PROGRAMMATIC_ADVICE_RECO_SUCCESS';
export const FETCHING_PROGRAMMATIC_ADVICE_RECO =
  'digitalAdvice/recommendation/FETCHING_PROGRAMMATIC_ADVICE_RECO';

type ComputeSize = (payload: number) => {
  payload: number;
  type: typeof COMPUTE_PROGRAMMATIC_ADVICE_RECO_SIZE;
};

type FetchFailed = (error: Error) => {
  error: Error;
  type: typeof FETCH_PROGRAMMATIC_ADVICE_RECO_FAILED;
};

type FetchSuccess = (
  payload: [ProgrammaticAdviceRecoLevel, ProgrammaticAdviceRecoProduct][],
) => {
  payload: [ProgrammaticAdviceRecoLevel, ProgrammaticAdviceRecoProduct][];
  type: typeof FETCH_PROGRAMMATIC_ADVICE_RECO_SUCCESS;
};

type Fetching = () => {
  type: typeof FETCHING_PROGRAMMATIC_ADVICE_RECO;
};

export const computeProgrammaticAdviceRecoSize: ComputeSize = (payload) => ({
  payload,
  type: COMPUTE_PROGRAMMATIC_ADVICE_RECO_SIZE,
});

export const fetchProgrammaticAdviceRecoProductsFailed: FetchFailed = (
  error,
) => ({
  error,
  type: FETCH_PROGRAMMATIC_ADVICE_RECO_FAILED,
});

export const fetchProgrammaticAdviceRecoProductsSuccess: FetchSuccess = (
  payload,
) => ({
  payload,
  type: FETCH_PROGRAMMATIC_ADVICE_RECO_SUCCESS,
});

export const fetchingProgrammaticAdviceRecoProducts: Fetching = () => ({
  type: FETCHING_PROGRAMMATIC_ADVICE_RECO,
});

export type Action =
  | ReturnType<ComputeSize | FetchFailed | FetchSuccess | Fetching>
  | HydrateAction<SpartacuxDigitalAdviceState>;
